var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 42,
    width: 10,
    height: 16,
    rx: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 42,
    width: 10,
    height: 16,
    rx: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 26,
    width: 10,
    height: 32,
    rx: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 26,
    width: 10,
    height: 32,
    rx: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,15.184l-7.649,7.649a5.015,5.015,0,1,0,1.414,1.414L19.816,16.6A7.017,7.017,0,0,1,18.4,15.184Z",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11,
    r: 5,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4,15.184l-7.649,7.649a4.966,4.966,0,0,0-5.506,0L29.6,15.184A7.017,7.017,0,0,1,28.184,16.6l7.649,7.649a5,5,0,1,0,8.334,0L51.816,16.6A7.017,7.017,0,0,1,50.4,15.184Z",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 11,
    r: 5,
    "data-color": "color-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.50f92136273f703895c856130168b4b0.svg";
export { ForwardRef as ReactComponent };